import axiosInstance from "./axiosInstance";
import { getDataCommon } from "./common";

export const getStandardData = () => getDataCommon("standard.json");

export const getStandardLawData = () => getDataCommon("standardlaw.json");

export const getStandardRegularData = () =>
  getDataCommon("standardregular.json");
